import { C } from '@ridgewill/brand';
import type { AgeBand } from '../lib/api.js';
import { Badge } from './ui.js';

/**
 * The age band from the date of birth on file (org-admin#187).
 *
 * On every account header, in a Family Group's member table, and beside each
 * result in "Add members", so a member under 18 is never handled as an adult by
 * mistake. Under 18 is a warn badge: it is the case staff must not miss, not an
 * error. The date itself is never shown here; it sits behind its own permission.
 *
 * `undefined` renders nothing: an auth older than #187 does not send the band,
 * and "no date of birth" would then be a claim nobody made.
 */
export function AgeBadge({ band }: { band: AgeBand | null | undefined }) {
  if (band === undefined) return null;
  if (band === null) {
    return (
      <span title="No date of birth on file" style={{ fontSize: '.75rem', color: C.muted, whiteSpace: 'nowrap' }}>
        no date of birth
      </span>
    );
  }
  return (
    <span title={band === '18+' ? '18 or older' : 'Under 18, by the date of birth on file'}>
      <Badge tone={band === '18+' ? 'neutral' : 'warn'}>{band}</Badge>
    </span>
  );
}

export const isMinorBand = (band: AgeBand | null | undefined) => band === '13-15' || band === '16-17';
